import createVueApp from '@/common/create_app'

Styxie.Initializers.AdminBusinesses = {
  index: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/businesses/index.vue')
    createVueApp(IndexPage, { props })
  },
  show: async(props) => {
    const { default: ShowPage } = await import('@/vue_widgets/admin/businesses/show.vue')
    createVueApp(ShowPage, { props })
  },
  new: async(props) => {
    const { default: FormPage } = await import('@/vue_widgets/admin/businesses/form.vue')
    createVueApp(FormPage, { props })
  },
  edit: async(props) => {
    const { default: FormPage } = await import('@/vue_widgets/admin/businesses/form.vue')
    createVueApp(FormPage, { props })
  },
  assign_mobile_businesses: async(props) => {
    const { default: AssignmentPage } = await import('@/vue_widgets/admin/businesses/mobile_business_assignment.vue')
    createVueApp(AssignmentPage, { props })
  }
}
